import is from '@sindresorhus/is';

import type { JobProfileVersion } from '~/shared/data-contract/job-profile-versions';

import { decodeHtmlEntities } from '../../../app/common/strings';
import type { JobItemDetails } from '../../api/use-job-item-details';

export const resolveVersionNote = (comment: JobProfileVersion['comment']): string | undefined =>
    is.string(comment) && comment.length > 0 ? decodeHtmlEntities(comment) : undefined;

export const canEditVersionNote = (currentVersion: JobProfileVersion, item: JobItemDetails): boolean =>
    currentVersion.reviewedAt === null && item.actions.canEdit;
